import startCase from 'lodash/startCase'

/**
 * APP MENU
 * {
 *   `entity`  used to check if current user has access to this
 *   `to`      routing path (default to /entity)
 *   `icon`    icon to shown in menu
 *   `text`    label to show in menu (default: ucfirst(entity))
 * }
 */
const menu = [
  {
    entity: 'dashboard',
    to: '/dashboard',
    icon: 'mdi-view-dashboard',
    text: 'Dashboard'
  },
  {
    entity: 'account',
    to: '/account',
    icon: 'mdi-account',
    text: 'Accounts'
  },
  {
    entity: 'user',
    to: '/user',
    icon: 'mdi-account-box-multiple',
    text: 'Users'
  },
  {
    entity: 'country',
    to: '/country',
    icon: 'mdi-map-marker',
    text: 'Countries'
  },
  {
    entity: 'protocol',
    to: '/protocol',
    icon: 'mdi-clipboard-text',
    text: 'Protocols'
  },
  {
    entity: 'site',
    to: '/site',
    icon: 'mdi-hospital-building',
    text: 'Sites'
  },
  {
    entity: 'protocol_has_site',
    to: '/protocol_has_site',
    icon: 'mdi-clipboard-list',
    text: 'Protocol Sites'
  },
  {
    entity: 'meddra',
    to: '/meddra',
    icon: 'mdi-book-alphabet',
    text: 'MedDRA'
  },
  {
    entity: 'smtp',
    to: '/smtp',
    icon: 'mdi-at',
    text: 'Smtp'
  },
  {
    entity: 'email',
    to: '/email',
    icon: 'mdi-email',
    text: 'Email'
  },
  {
    entity: 'redcap_deploy',
    to: '/redcap_deploy',
    icon: 'mdi-cloud-upload',
    text: 'REDCap Deploy'
  },
  {
    entity: 'maintenance',
    to: '/maintenance',
    icon: 'mdi-wrench-clock',
    text: 'Maintenance'
  }     
]

export default menu.map(item => ({
  type: item.type || 'core-drawer-link',
  entity: item.entity,
  action: item.action || 'read',
  to: item.to || `/${item.entity}`,
  icon: item.icon,
  text: item.text || startCase(item.entity),
  links: item.links ?
    item.links.map(l => ({
      entity: l.entity,
      action: l.action || 'read',
      to: l.to || `/${l.entity}`,
      icon: l.icon,
      text: l.text || startCase(l.entity),      
    })) : []
}))
